import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading, serverWaking, authError, checkAuth } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6" data-testid="loading-screen">
        <div className="text-center max-w-sm">
          <div className="w-8 h-8 mx-auto border-2 border-[#FF6B1A] border-t-transparent rounded-full animate-spin" />
          <p className="mt-4 font-heading font-bold uppercase tracking-wide text-white">
            {serverWaking ? 'Waking up the Posse…' : 'Loading your account…'}
          </p>
          {serverWaking && (
            <p className="mt-2 text-sm text-white/45">
              The secure server is starting. Your screen will open automatically.
            </p>
          )}
        </div>
      </div>
    );
  }

  if (authError && !user) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6" data-testid="server-unavailable-screen">
        <div className="card-tactical rounded-md p-7 text-center max-w-sm w-full">
          <p className="font-heading font-black text-xl uppercase text-white">Server took too long</p>
          <p className="mt-2 text-sm text-white/50">Your account is safe. Try the connection again.</p>
          <button
            type="button"
            onClick={checkAuth}
            className="mt-5 w-full rounded-md bg-[#FF6B1A] px-4 py-3 font-heading font-bold uppercase text-white hover:bg-[#FF853E] transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
